export enum FeatureFlagName {
  // Operational rollback for the required legal agreement.
  terms_of_service = "terms_of_service",

  // Idle Logout Feature
  idle_logout = "idle_logout",

  // Deprecated 2026-11-03: Show/Hide Password toggle is always on; flag is no longer read
  // password_visibility_toggle = "password_visibility_toggle",

  // Redirection Feature
  auto_redirect_to_reporting = "auto_redirect_to_reporting",
  auto_redirect_to_student_experience = "auto_redirect_to_student_experience",

  // Reporting Module Feature
  reporting_module = "reporting_module",

  // Reporting Insights Module Features
  reporting_insights_usage_module = "reporting_insights_usage_module",
  reporting_insights_activity_log_module = "reporting_insights_activity_log_module",
  reporting_insights_performance_module = "reporting_insights_performance_module",
  reporting_insights_performance_questions_module = "reporting_insights_performance_questions_module",
  reporting_insights_performance_questions_content_filter = "reporting_insights_performance_questions_content_filter",
  reporting_insights_performance_questions_show_all_programs = "reporting_insights_performance_questions_show_all_programs",
  reporting_insights_performance_answers_module = "reporting_insights_performance_answers_module",
  reporting_insights_performance_goals_module = "reporting_insights_performance_goals_module",
  reporting_insights_performance_content_mastery_module = "reporting_insights_performance_content_mastery_module",
  reporting_insights_performance_content_mastery_hide_eact = "reporting_insights_performance_content_mastery_hide_eact",
  reporting_insights_performance_questions_standard = "reporting_insights_performance_questions_standard",
  reporting_insights_performance_questions_viewed = "reporting_insights_performance_questions_viewed",
  reporting_insights_activity_log_time_spent = "reporting_insights_activity_log_time_spent",
  reporting_skills_filter = "reporting_skills_filter",
  reporting_grade_column = "reporting_grade_column",
  reporting_level_filter = "reporting_level_filter",
  reporting_level_column = "reporting_level_column",

  // Reporting Content Module Features
  reporting_content_module = "reporting_content_module",
  reporting_content_library_widgets = "reporting_content_library_widgets",
  reporting_content_library_standards = "reporting_content_library_standards",
  reporting_content_library_date_filter = "reporting_content_library_date_filter",
  reporting_content_library_average_accuracy = "reporting_content_library_average_accuracy",
  reporting_content_library_download_resources = "reporting_content_library_download_resources",
  reporting_content_library_reporting_categories = "reporting_content_library_reporting_categories",
  reporting_content_library_skill_review_mastery_curriculum = "reporting_content_library_skill_review_mastery_curriculum",
  reporting_assign_lessons_from_content = "reporting_assign_lessons_from_content",

  // Reporting Organization Module Features
  reporting_organization_module = "reporting_organization_module",
  reporting_organization_license_assign_module = "reporting_organization_license_assign_module",
  reporting_organization_bypass_scope_gate = "reporting_organization_bypass_scope_gate",
  reporting_organization_student_performance_report = "reporting_organization_student_performance_report",
  // Lets Super Administrators type a password in the Add/Edit user modals;
  // everyone else can only use the Generate button

  // Reporting Teaching Tools Module Features
  reporting_teaching_tools_module = "reporting_teaching_tools_module",
  reporting_teaching_tools_mastery_curriculum_module = "reporting_teaching_tools_mastery_curriculum_module",
  reporting_teaching_tools_legacy_mastery_curriculum_module = "reporting_teaching_tools_legacy_mastery_curriculum_module",
  reporting_teaching_tools_skill_review_module = "reporting_teaching_tools_skill_review_module",
  reporting_teaching_tools_e_books_module = "reporting_teaching_tools_e_books_module",
  reporting_teaching_tools_test_administration_module = "reporting_teaching_tools_test_administration_module",
  reporting_teaching_tools_assignments_drill_in = "reporting_teaching_tools_assignments_drill_in",

  // Reporting Data Features
  reporting_average_time_spent_data = "reporting_average_time_spent_data",
  reporting_average_days_active_data = "reporting_average_days_active_data",
  reporting_content_attempts_legacy = "reporting_content_attempts_legacy",
  reporting_content_attempts_tickets = "reporting_content_attempts_tickets",
  adaptive_engine_middleman = "adaptive_engine_middleman",

  // Student Experience Module Features
  student_experience_module = "student_experience_module",
  student_experience_insights_module = "student_experience_insights_module",
  student_experience_insights_completions_module = "student_experience_insights_completions_module",
  student_experience_insights_skills_module = "student_experience_insights_skills_module",
  student_experience_insights_questions_module = "student_experience_insights_questions_module",
  student_experience_study_hall_module = "student_experience_study_hall_module",
  student_experience_practice_tests_module = "student_experience_practice_tests_module",
  student_experience_content_library_module = "student_experience_content_library_module",
  student_experience_mastery_resources_module = "student_experience_mastery_resources_module",
  student_experience_performance_report = "student_experience_performance_report",
  // TI-108 calculator on the Ready#7749 surfaces: WKAM lessons, the WKAM diagnostic and ACT/EACT Math lessons
  student_experience_calculator = "student_experience_calculator",
  // Applied Math formula sheet in lessons, the diagnostic and qti-pwa quizzes
  student_experience_formula_sheet = "student_experience_formula_sheet",
  // Mux Features
  video_use_mux_captions_students = "video_use_mux_captions_students",
  // Study Plan Module Features for Editing on WorkKeys
  study_plan_edit_mode_workkeys = "study_plan_edit_mode_workkeys",
  study_plan_scores_by_student_module = "study_plan_scores_by_student_module",

  // Filter Data Provider Features
  use_cube_filters = "use_cube_filters",

  // Dashboard Level Widget Feature
  student_experience_level_widget = "student_experience_level_widget",

  // Read Aloud Features
  read_aloud_for_student_view = "read_aloud_for_student_view",
  read_aloud_highlighting = "read_aloud_highlighting",

  // Clarity Features
  enable_microsoft_clarity = "enable_microsoft_clarity",

  // MOS chat widget
  mos_chat_widget = "mos_chat_widget",

  // GraphQL specific features
  reporting_graphql_usage_students = "reporting_graphql_usage_students",
  reporting_graphql_usage_student_widgets = "reporting_graphql_usage_student_widgets",
  reporting_graphql_usage_teachers = "reporting_graphql_usage_teachers",
  reporting_graphql_usage_activity_log = "reporting_graphql_usage_activity_log",
  reporting_graphql_educator_content_library = "reporting_graphql_educator_content_library",
  reporting_graphql_organization_students = "reporting_graphql_organization_students",
  reporting_graphql_organization_organizations = "reporting_graphql_organization_organizations",
  reporting_graphql_organization_states = "reporting_graphql_organization_states",
  reporting_graphql_organization_districts = "reporting_graphql_organization_districts",
  reporting_graphql_organization_schools = "reporting_graphql_organization_schools",
  reporting_graphql_organization_classes = "reporting_graphql_organization_classes",
  reporting_graphql_organization_admins = "reporting_graphql_organization_admins",
  reporting_graphql_organization_teachers = "reporting_graphql_organization_teachers",
  reporting_graphql_widget_active_states = "reporting_graphql_widget_active_states",
  reporting_graphql_widget_active_students = "reporting_graphql_widget_active_students",
  reporting_graphql_widget_active_districts = "reporting_graphql_widget_active_districts",
  reporting_graphql_widget_active_schools = "reporting_graphql_widget_active_schools",
  reporting_graphql_widget_active_teachers = "reporting_graphql_widget_active_teachers",
  reporting_graphql_widget_active_classes = "reporting_graphql_widget_active_classes",
  reporting_graphql_widget_active_district_admins = "reporting_graphql_widget_active_district_admins",
  reporting_graphql_widget_active_school_admins = "reporting_graphql_widget_active_school_admins",
  reporting_graphql_widget_active_organizations = "reporting_graphql_widget_active_organizations",
  reporting_graphql_widget_active_organization_admins = "reporting_graphql_widget_active_organization_admins",
  reporting_graphql_performance_scores = "reporting_graphql_performance_scores",
  reporting_graphql_performance_average_score_widgets = "reporting_graphql_performance_average_score_widgets",
  reporting_graphql_programs_with_overall_score_range = "reporting_graphql_programs_with_overall_score_range",

  // Test filter features
  reporting_test_filter_show_eact_writing = "reporting_test_filter_show_eact_writing",

  reporting_content_preview = "reporting_content_preview",
  reporting_content_library_preview = "reporting_content_library_preview",
  reporting_configuration_platform_settings_module = "reporting_configuration_platform_settings_module"
}

export type FeatureFlagStrategy = {
  name: string
  parameters: any
}

export type FeatureFlagBase = {
  name: string
  enabled: boolean
}

export type FeatureFlag = FeatureFlagBase & {
  description?: string
  strategies?: FeatureFlagStrategy[]
}

export type FeatureFlagStatesType = Partial<{
  [name in FeatureFlagName]: boolean
}>
